import { render, staticRenderFns } from "./transaction-moves.vue?vue&type=template&id=63760d08&"
import script from "./transaction-moves.vue?vue&type=script&lang=ts&"
export * from "./transaction-moves.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports